module.exports = __webpack_public_path__ + "img/settings-disabled.50161e5c.svg";